// Phase C.6 — shared canonical grade list, matching the athletes.grade /
// team_athletes.season_grade CHECK constraint exactly (005, extended
// 047). A small, closed, effectively permanent enumeration, same
// reasoning as footballPositions.js — extracted here so AthleteForm.js
// (the athlete's own current grade) and the roster-details editor
// (a membership's own historical season_grade) share one list instead
// of two independently-maintained copies.
export const GRADES = ['K','1','2','3','4','5','6','7','8','9','10','11','12','Unknown'];
